<template>
  <div
    v-if="currentRegisterType"
    class="relative-position"
    :class="preview ? 'column' : 'column fixed-full'"
    :style="preview ? 'height: 1000px' : ''"
  >
    <playing-today-carousel
      v-if="isFullScreenCarouselTemplate"
      class="absolute-full full-height full-width"
      style="filter: brightness(0.7);"
      is-full-screen
      clean-image
      :show-trailer="currentRegisterType.kioskOptions.homepage_carousel_include_trailer_autoplay"
      @movie-selected="(movieId) => $emit('movie-selected', movieId)"
    />
    <div
      class="column justify-center items-center"
      :class="showConcessionsButton && !$isLandscapeView() && isFullScreenCarouselTemplate ? 'col-3' : 'col-2'"
    >
      <img
        class="z-top"
        style="max-height: 50%; max-width: 90%; object-fit: contain;"
        :src="logoImage"
      >
    </div>
    <div
      v-if="!isFullScreenCarouselTemplate"
      class="z-top"
      :class="$isLandscapeView() ? undefined : 'q-mx-lg'"
      style="contain: content;"
    >
      <playing-today-carousel
        v-if="currentRegisterType.kioskOptions.homepage_advertising_display_type === KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES.PLAYING_TODAY_CAROUSEL"
        :allow-buy-tickets="showTicketPurchaseButton"
        :show-trailer="currentRegisterType.kioskOptions.homepage_carousel_include_trailer_autoplay"
        @movie-selected="(movieId) => $emit('movie-selected', movieId)"
      />
      <signage-component
        v-else-if="currentRegisterType.kioskOptions.homepage_advertising_display_type === KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES.SIGNAGE && !!currentRegisterType.kioskOptions.homepage_signage_url"
        :key="currentRegisterType.kioskOptions.homepage_signage_url"
        :display-url="currentRegisterType.kioskOptions.homepage_signage_url"
        :style="{ 'min-height': $isLandscapeView() ? '45vh' : '35vh' }"
      />
    </div>
    <div
      class="column col q-ma-lg items-center"
      :class="isFullScreenCarouselTemplate ? 'justify-start' : 'justify-center'"
    >
      <div
        v-if="allowedToProceed"
        class="col-auto full-width items-center"
        :class="{
          'row q-gutter-x-xl  justify-center': $isLandscapeView(),
          'column q-gutter-y-lg q-mb-xl': !$isLandscapeView(),
          'justify-evenly': !$isLandscapeView() && isFullScreenCarouselTemplate,
          'full-height items-center self-center': isFullScreenCarouselTemplate,
          'q-pb-xl': $q.screen.gt.sm
        }"
        :style="{ 'max-height': showConcessionsButton && !$isLandscapeView() && isFullScreenCarouselTemplate ? '600px' : undefined }"
      >
        <q-btn
          v-if="showTicketPurchaseButton"
          rounded
          :padding="isLargeScreen ? 'lg' : 'md'"
          :size="fontSize"
          :color="isFullScreenCarouselTemplate ? 'white': 'primary'"
          :text-color="isFullScreenCarouselTemplate ? 'primary': buttonTextColor(currentSite.primaryColor)"
          class="text-bold q-ml-none"
          :class="{ 'shadow-2': isButtonSquare && $q.screen.gt.sm }"
          :style="buttonStyle"
          :stack="isButtonSquare"
          @click="() => actionSelected(ACTIONS.ALL_SHOWINGS)"
        >
          <q-icon
            :left="!isButtonSquare"
            :size="isButtonSquare ? '1.5em' : '0.9em'"
            name="fal fa-ticket"
          />
          <div
            :class="isButtonSquare ? 'q-mt-md' : undefined"
            :style="{ 'line-height': isButtonSquare ? '1' : undefined }"
          >
            {{ $tc('ticket.actions.buy', 2) }}
          </div>
        </q-btn>
        <q-btn
          v-if="showActivitiesPurchaseButton"
          rounded
          :padding="isLargeScreen ? 'lg' : 'md'"
          :size="fontSize"
          :color="isFullScreenCarouselTemplate ? 'white': 'primary'"
          :text-color="isFullScreenCarouselTemplate ? 'primary': buttonTextColor(currentSite.primaryColor)"
          class="text-bold"
          :class="{ 'shadow-2': isButtonSquare && $q.screen.gt.sm }"
          :style="buttonStyle"
          :stack="isButtonSquare"
          @click="() => actionSelected(ACTIONS.ALL_ACTIVITIES)"
        >
          <q-icon
            :left="!isButtonSquare"
            :size="isButtonSquare ? '1.5em' : '0.9em'"
            name="fal fa-table-tennis-paddle-ball"
          />
          <div
            :class="isButtonSquare ? 'q-mt-md' : undefined"
            :style="{ 'line-height': isButtonSquare ? '1' : undefined }"
          >
            {{ $tc('ticket.actions.playGames', 2) }}
          </div>
        </q-btn>
        <q-btn
          v-if="order.user"
          rounded
          :padding="isLargeScreen ? 'lg' : 'md'"
          :size="fontSize"
          :color="isFullScreenCarouselTemplate ? 'white' : 'secondary'"
          :text-color="isFullScreenCarouselTemplate ? 'primary' : buttonTextColor(currentSite.secondaryColor)"
          class="text-bold"
          :class="{ 'shadow-2': isButtonSquare && $q.screen.gt.sm }"
          :style="buttonStyle"
          :stack="isButtonSquare"
          @click="() => $router.push('membership-action')"
        >
          <q-icon
            :left="!isButtonSquare"
            :size="isButtonSquare ? '1.5em' : '0.9em'"
            name="fal fa-user"
          />
          <div
            :class="isButtonSquare ? 'q-mt-md' : undefined"
            :style="{ 'line-height': isButtonSquare ? '1' : undefined }"
          >
            {{ $t('membership.actions.manage') }}
          </div>
        </q-btn>
        <q-btn
          v-else
          rounded
          :padding="isLargeScreen ? 'lg' : 'md'"
          :size="fontSize"
          :color="isFullScreenCarouselTemplate ? 'white' : 'secondary'"
          :text-color="isFullScreenCarouselTemplate ? 'primary' : buttonTextColor(currentSite.secondaryColor)"
          class="text-bold"
          :class="{ 'shadow-2': isButtonSquare && $q.screen.gt.sm }"
          :style="buttonStyle"
          :stack="isButtonSquare"
          @click="() => $router.push('membership-action')"
        >
          <q-icon
            :left="!isButtonSquare"
            :size="isButtonSquare ? '1.5em' : '0.9em'"
            name="fal fa-user"
          />
          <div
            :class="isButtonSquare ? 'q-mt-md' : undefined"
            :style="{ 'line-height': isButtonSquare ? '1' : undefined }"
          >
            {{ $t('membership.actions.memberLogIn') }}
          </div>
        </q-btn>
        <q-btn
          v-if="showConcessionsButton"
          rounded
          :padding="isLargeScreen ? 'lg' : 'md'"
          :size="fontSize"
          :color="isFullScreenCarouselTemplate ? 'white': 'primary'"
          :text-color="isFullScreenCarouselTemplate ? 'primary': buttonTextColor(currentSite.primaryColor)"
          class="text-bold"
          :class="{ 'shadow-2': isButtonSquare && $q.screen.gt.sm }"
          :style="buttonStyle"
          :stack="isButtonSquare"
          @click="() => $router.push('/checkout/items')"
        >
          <q-icon
            :left="!isButtonSquare"
            :size="isButtonSquare ? '1.5em' : '0.9em'"
            name="fal fa-burger-soda"
          />
          <div
            :class="isButtonSquare ? 'q-mt-md' : undefined"
            :style="{ 'line-height': isButtonSquare ? '1' : undefined }"
          >
            {{ $t('pages.payment.foodAndDrinkHeading') }}
          </div>
        </q-btn>
        <q-btn
          v-if="!isTicketPrintingDisabled"
          rounded
          :padding="isLargeScreen? 'lg' : 'md'"
          :size="fontSize"
          :color="$q.dark.isActive || isFullScreenCarouselTemplate ? 'white' : 'dark'"
          :text-color="isFullScreenCarouselTemplate ? 'primary' : undefined"
          :outline="currentRegisterType.kioskOptions.homepage_advertising_display_type !== KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES.FULL_SCREEN_CAROUSEL"
          class="text-bold"
          :class="{ 'shadow-2': isButtonSquare && $q.screen.gt.sm }"
          :style="buttonStyle"
          :stack="isButtonSquare"
          @click="() => $router.push('pickup')"
        >
          <q-icon
            :left="!isButtonSquare"
            :size="isButtonSquare ? '1.5em' : '0.9em'"
            name="fal fa-print"
          />
          <div
            :class="isButtonSquare ? 'q-mt-md' : undefined"
            :style="{ 'line-height': isButtonSquare ? '1' : undefined }"
          >
            {{ $tc('ticket.actions.print', 2) }}
          </div>
        </q-btn>
      </div>
      <q-card
        v-else
        class="col-auto z-top bg-responsive-white text-center column justify-center items-center self-center"
        style="max-width: 70vw;"
        bordered
      >
        <q-card-section class="bg-warning full-width">
          <q-icon
            name="fal fa-cloud-exclamation"
            :size="$q.screen.lt.md ? 'lg' : 'xl'"
            class="q-mx-xl"
            :color="$isColorDark(currentSite.warningColor) ? 'white' : 'black'"
          />
        </q-card-section>
        <q-card-section
          class="q-ma-lg"
          :class="$q.screen.lt.md ? 'text-h5' : 'text-h4'"
        >
          {{ $t('kiosk.errors.underMaintenance') }}.
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script>
import { Dark } from 'quasar'
import { imgixHost, indySplashImage } from 'src/config'
import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import { KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES } from 'src/models/register/RegisterType'
import { useHasPurchasableFood } from 'src/modules/checkout/composables/sales-availability/hasPurchasableFood'
import { useSalesChannel } from 'src/modules/checkout/composables/sales-channels/SalesChannel'
import PlayingTodayCarousel from 'src/modules/kiosk/components/PlayingTodayCarousel'
import { ACTIONS } from 'src/modules/kiosk/layouts/KioskLayout'
import SignageComponent from 'src/modules/signage/SignageComponent'

export default {
  name: 'ActionSelectionPage',
  components: {
    PlayingTodayCarousel,
    SignageComponent
  },
  configuration: ['currentSite', 'categories', 'items'],
  context: ['currentRegisterClient'],
  inject: ['order'],
  props: {
    registerType: {
      type: Object,
      required: false,
      default: null
    },
    allowedToProceed: {
      type: Boolean,
      required: false,
      default: false
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['movie-selected', 'action-selected'],
  setup () {
    const { hasPurchasableFood } = useHasPurchasableFood()
    const { computeSalesChannel } = useSalesChannel()

    return {
      hasPurchasableFood,
      computeSalesChannel
    }
  },
  computed: {
    salesChannel () {
      return this.computeSalesChannel(SALES_CHANNEL_TYPES.MENU, this.order)
    },
    currentRegisterType () {
      return this.registerType || this.currentRegisterClient?.registerStation?.registerType
    },
    logoImage () {
      const isFullScreenCarousel = this.currentRegisterType.kioskOptions.homepage_advertising_display_type === KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES.FULL_SCREEN_CAROUSEL
      let image = this.$q.dark.isActive || isFullScreenCarousel ? this.currentSite.lightLogoImage : this.currentSite.darkLogoImage
      image ||= indySplashImage
      return `${imgixHost}/${image}?auto=format,compress`
    },
    isButtonSquare () {
      return this.$isLandscapeView() || this.currentRegisterType.kioskOptions.homepage_advertising_display_type === KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES.FULL_SCREEN_CAROUSEL
    },
    buttonStyle () {
      const style = []
      if (this.isButtonSquare) {
        if (this.$q.screen.lt.md) {
          style.push(`
          width: ${this.$isLandscapeView() ? '160px' : '200px'};
          height: ${this.$isLandscapeView() ? '160px' : '200px'};
          border-radius: ${this.$isLandscapeView() ? '15px' : '30px'};
          padding: ${this.$isLandscapeView() ? '10px' : '15px'};
          `)
        } else {
          style.push(`
          width: ${this.$isLandscapeView() ? '200px' : '240px'};
          height: ${this.$isLandscapeView() ? '200px' : '240px'};
          border-radius: ${this.$isLandscapeView() ? '30px' : '50px'};
          padding: ${this.$isLandscapeView() ? '10px' : '20px'};
          `)
        }
      } else {
        style.push('min-width: 80%;')
        style.push('border-radius: 10px;')
      }
      if (this.isFullScreenCarouselTemplate) {
        style.push('opacity: 0.8;')
      }

      return style.join(';')
    },
    fontSize () {
      if (this.isButtonSquare && this.$q.screen.gt.sm) {
        return this.$isLandscapeView() ? '20px' : '40px'
      } else {
        return this.isLargeScreen ? '30px' : 'xl'
      }
    },
    isFullScreenCarouselTemplate () {
      return this.currentRegisterType.kioskOptions.homepage_advertising_display_type === KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES.FULL_SCREEN_CAROUSEL
    },
    isLargeScreen () {
      return (this.$q.screen.gt.sm && this.$isLandscapeView()) || this.$q.screen.gt.md
    },
    showConcessionsButton () {
      if (!this.currentRegisterType?.kioskOptions?.show_food_and_beverage_on_homepage) return false

      const hasPurchasableFood = this.hasPurchasableFood({
        categories: this.categories.data,
        items: this.items.data,
        salesChannel: this.salesChannel,
        order: this.order,
        registerType: this.currentRegisterType,
        showing: this.order?.currentShowing || this.order?.nextShowing
      })

      return hasPurchasableFood
    },
    isTicketPrintingDisabled () {
      return this.currentRegisterType?.kioskOptions?.disable_ticket_printing
    },
    showTicketPurchaseButton () {
      return this.currentRegisterType?.kioskOptions?.show_ticket_purchase_on_homepage
    },
    showActivitiesPurchaseButton () {
      return this.currentRegisterType?.kioskOptions?.show_activities_purchase_on_homepage
    }
  },
  created () {
    _.extend(this, { KIOSK_HOMEPAGE_ADVERTISING_DISPLAY_TYPES })
    // For Dark Mode toggle
    if (this.$kiosk) {
      Dark.set(this.currentSite.consumerConfig.darkMode)
    }
  },
  mounted () {
    _.extend(this, { ACTIONS })
  },
  methods: {
    actionSelected (action) {
      this.$emit('action-selected', action)
    },
    buttonTextColor (color) {
      return this.$isColorDark(color) ? 'white' : 'black'
    }
  }
}
</script>

<style scoped lang="scss">
.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
